import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const COLORS = ['#6366F1', '#22C55E', '#F97316', '#9CA3AF', '#A5B4FC', '#6EE7B7'];

const buildChartOptions = (labels) => ({
  chart: { type: 'donut', toolbar: { show: false }, fontFamily: 'inherit' },
  labels,
  colors: COLORS.slice(0, labels.length),
  legend: { show: false },
  dataLabels: { enabled: false },
  plotOptions: {
    pie: {
      donut: { size: '60%' },
    },
  },
  stroke: { width: 0 },
  tooltip: {
    y: { formatter: (v) => `${v}%` },
  },
});

const PayorMixChart = ({ requestData }) => {
  const [payorMixData, setPayorMixData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getPayorMixChart(requestData);

        setPayorMixData(data.data || []);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const labels = payorMixData.map((r) => r.name);
  const series = payorMixData.map((r) => r.percent);

  return (
    <div style={{ padding: 16 }} className={classes.chart_kpi_wrapper}>
      <p style={{
        margin: '0 0 4px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        Payer mix
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : !payorMixData.length
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <>
              <Chart
                type="donut"
                height={260}
                series={series}
                options={buildChartOptions(labels)}
              />

              <div style={{ marginTop: 8 }}>
                {payorMixData.map((row, idx) => (
                  <div
                    key={row.name}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      fontSize: 13,
                      color: '#374151',
                      marginBottom: 6,
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{
                        width: 10,
                        height: 10,
                        borderRadius: 2,
                        background: COLORS[idx] ?? COLORS[COLORS.length - 1],
                        flexShrink: 0,
                      }}
                      />
                      <span>{row.name}</span>
                    </div>

                    <span style={{ fontWeight: 700, color: '#111827' }}>{`${row.percent}%`}</span>
                  </div>
                ))}
              </div>
            </>
          )}
    </div>
  );
};

export default PayorMixChart;
